exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-ac-migrate-tsx": () => import("./../../../src/pages/ac-migrate.tsx" /* webpackChunkName: "component---src-pages-ac-migrate-tsx" */),
  "component---src-pages-crate-editor-tsx": () => import("./../../../src/pages/crate-editor.tsx" /* webpackChunkName: "component---src-pages-crate-editor-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

